import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import Rating from 'lib/components/rating'
import I18n from 'lib/i18n'

const LessonReview = ({ review, dpr, isSearchPage }) => {
  const isRetina = ((typeof window !== 'undefined' && window && window.devicePixelRatio) || dpr) >= 2
  const photo = isRetina ? review.photo_retina : review.photo

  return (
    <div className={`widget coursebox noborder review${isSearchPage ? ' bg-search-page' : ''}`}>
      <div className='teacher'>
        <LazyLoadImage src={photo} className='teacher-photo' height={60} width={60} alt={review.course_avatar_alt} />
        <div className='teacher-type' title={review.course}>
          {review.course}
        </div>
        <div className='teacher-name'>{review.teacher}</div>
        <div className='teacher-stars'>
          <Rating percentage={review.stars * 20} />
        </div>
      </div>
      <div className='actual-review'>{review.review}</div>
      <div className='reviewed'>
        {I18n.t('react.homepage.reviews.review_by', { name: review.student.toUpperCase() })}
      </div>
    </div>
  )
}

LessonReview.propTypes = {
  review: PropTypes.object.isRequired,
  dpr: PropTypes.number.isRequired,
  isSearchPage: PropTypes.bool
}

export default LessonReview
